import axios from "axios";
import env from "../../constants/apiConst";

export const __typesOfIdentifications = async (token, body, page) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(
    `${env.TYPE_OF_IDENTIFICATIONS_GET}?page=${page || 1}`,
    options
  );
  return res;
}
